import { render, staticRenderFns } from "./ModalReportProblemFeedback.vue?vue&type=template&id=031a144e&scoped=true"
import script from "./ModalReportProblemFeedback.vue?vue&type=script&lang=ts"
export * from "./ModalReportProblemFeedback.vue?vue&type=script&lang=ts"
import style0 from "./ModalReportProblemFeedback.scss?vue&type=style&index=0&id=031a144e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a144e",
  null
  
)

export default component.exports